// https://www.apollographql.com/docs/react/api/react-apollo#graphql-config-options-fetchPolicy
export const CACHE_ONLY = 'cache-only';
export const NETWORK_ONLY = 'network-only';
export const NO_CACHE = 'no-cache';
export const CACHE_AND_NETWORK = 'cache-and-network';

export default {
  CACHE_ONLY,
  NETWORK_ONLY,
  CACHE_AND_NETWORK,
  NO_CACHE
};
